// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import env from './.env';
import { b2cPolicies, Client } from '@app/auth-config';
const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export const environment = {    
  production: false,
  version: env.npm_package_version + '-dev',
  serverUrl: 'https://find.crs.com/api', // http://profusion-findcrs-dev.northcentralus.cloudapp.azure.com/api
  envName: 'DEV',
  signalRBaseUrl: 'http://findcrsrealtimehub.azurewebsites.net/api',
  msalConfig: {                           
    auth: {                                                                                      
      clientId: Client.ID,            
      authority: b2cPolicies.authorities.signUpSignIn.authority,
      knownAuthorities: [b2cPolicies.authorityDomain],
      redirectUri: "https://find.crs.com/",
      postLogoutRedirectUri: "https://find.crs.com/",    
      validateAuthority: true,      
      navigateToLoginRequestUrl: true,                            
    },                                                                                                                    
    cache: {                                     
      cacheLocation: "localStorage",
      storeAuthStateInCookie: isIE,
    }   
  }
};
// http://findacrs-ui.profusionsystems.com
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
